<template>
	<div class="box_mian" ref="pageRef">
		<div class="header_box">
			<Header />
		</div>

		<el-row class="carousel_box">
			<el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
				<el-carousel v-if="lbArr.length">
					<el-carousel-item v-for="(item, index) in lbArr" :key="index">
						<img class="carousel_img" :src="item.url" alt="" />
					</el-carousel-item>
				</el-carousel>
			</el-col>
		</el-row>

		<el-row class="content_box">
			<el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
				<router-view />
			</el-col>
		</el-row>

		<el-row class="footer">
			<el-col>
				<footerBox :nubFoot="nubFoot" />
			</el-col>
		</el-row>
	</div>
</template>

<script setup>
import { ref, onUnmounted, watch, onMounted } from "vue";
import { useStore } from 'vuex';
import http from "@/utils/api";
import footerBox from "@/components/footer.vue";
import Header from "@/components/header.vue";

const store = useStore();
let nubFoot = ref(1);
let lbArr = ref([]);

// 组件挂载时检查登录状态
onMounted(() => {
	if (store.state.isLoggedIn) {
		getLbt();
    getCCtoken();
	}
});

//轮播图
const getLbt = async () => {
  let res = await http.base.NewsQuery({
    page: 1,
    limit: 10,
    orgId: '',
    date: "",
    select: "type,url,id",
    where: `type like '%ccLbt%'`,
    sortby: "sort desc",
  });
  if (res && res.code == 0) {
    lbArr.value = res.data.data || [];
  }
};

const getCCtoken = async () => {
  let res = await http.ccObj.token({
    password: "3e012fb6-33aa-458a-b3f2-7331de0f0577",
    userName: "rest_bpm",
    loginName: "OA1",
  });
  if (res) {
    sessionStorage.setItem("ccToken", res.data);
  }
};

// 监听仓库中的登录状态变化
watch(() => store.state.isLoggedIn, (newVal) => {
  if (newVal) {
    getLbt();
    getCCtoken();
  }
});
</script>

<style scoped lang="scss">
	@import "@/assets/home.scss";

	.carousel_box {
		display: flex;
		justify-content: center;
		width: 100%;
		height: 450px;
		margin-bottom: 20px;
		margin: 0 auto;
		margin-top: 60px;

		.carousel_img {
			width: 100%;
			height: 100%;
		}

		::v-deep .el-carousel__container {
			height: 450px!important;
		}
	}

.content_box {
	display: flex;
	justify-content: center;
	margin-top: 20px;
}

.footer {
	width: 100%;
	display: flex;
	justify-content: center;
}

@media screen and (max-width: 768px) {
	.box_mian {
		background: #f2f2f2;
	}
	
	.carousel_box {
		height: 200px;
		margin-top: 0px;
		::v-deep .el-carousel__container {
			height: 200px!important;
		}
	}
}

</style>